export default {"src":"/_next/static/media/profile-details.7a3395e6.svg","height":400,"width":400,"blurWidth":0,"blurHeight":0};